module.exports = __webpack_public_path__ + "img/icon_shangla.e07a70ed.png";